import React, { useState, useContext, useMemo } from 'react'
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Divider,
  ListItemIcon,
  MenuItem,
  Menu,
  Hidden,
} from '@mui/material'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import LogoutIcon from '@mui/icons-material/Logout'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import { ADMIN_PANEL, STAFF_BENEFIT_ADMIN } from '../../constant/permission'
import { useLocation } from 'react-router-dom'
import { UserAuthContext } from '../../api/context/UserAuthContext'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'

const StyledButton = styled(Button)`
  && {
    color: #000;
    :hover {
      color: #0c479d;
    }
  }
`

export const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const openUserMenu = Boolean(anchorEl)
  const { user } = useContext(UserAuthContext)

  const userPermission = user?.permission

  const userPermissionForAdminPanel =
    userPermission?.includes(ADMIN_PANEL) || userPermission?.includes(STAFF_BENEFIT_ADMIN)

  const adminPanelRedirectLink = useMemo(() => {
    if (userPermission?.includes(ADMIN_PANEL)) {
      return '/admin'
    } else {
      return '/staff-benefit'
    }
  }, [userPermission])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const location = useLocation()

  const handleLogout = async () => {
    // const res = await mutateAsync()
    // await refetch()
    const { pathname = '', search = '' } = location
    let returnTo = ''
    if (pathname || search) {
      returnTo = new URLSearchParams({
        return_to: `${pathname}${search ? `?${search}` : ''}`,
      }).toString()
      returnTo = '?' + returnTo
    }

    window.location.href = `/logout${returnTo}`
  }

  const renderUserMenu = (
    <Menu
      anchorEl={anchorEl}
      id='account-menu'
      open={openUserMenu}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem component={Link} to='/my-profile'>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        My Profile
      </MenuItem>
      <Divider />
      {userPermissionForAdminPanel && (
        <Hidden mdUp>
          <MenuItem component={Link} to={adminPanelRedirectLink}>
            <ListItemIcon>
              <ManageAccountsIcon />
            </ListItemIcon>
            Admin Panel
          </MenuItem>
          <Divider />
        </Hidden>
      )}
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  )

  return (
    <>
      <AppBar color='inherit'>
        <Toolbar>
          <Box display='flex' justifyContent='space-between' width='100%'>
            <Link to='/'>
              <Box display='flex' align='center' pr={1}>
                <img src='/images/HTGROUP_IMG.png' width={150} height={38} alt='htgroup logo' />
              </Box>
            </Link>
            <Box>
              {userPermissionForAdminPanel && (
                <Hidden mdDown>
                  <StyledButton to={adminPanelRedirectLink} component={Link}>
                    Admin Panel
                  </StyledButton>
                </Hidden>
              )}
              <StyledButton onClick={handleClick} style={{ textDecoration: 'underline' }}>
                {user?.name ? user?.name : user?.email}
              </StyledButton>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
      {renderUserMenu}
    </>
  )
}
